import { useState } from "react";

export interface TabItem {
  /** unique identifies for the tab item used to display tabs */
  key: string;
  /** label for the tab item used to display tabs */
  label: string;
}

/**
 * Custom hook to handle tabs states
 */
const useTabs = (tabs: TabItem[]) => {
  const [activeTab, setActiveTab] = useState(tabs[0]?.key || "");

  const activeLabel = tabs.find((tab) => tab.key === activeTab)?.label || "";

  const changeTab = (key: string) => {
    setActiveTab(key);
  };

  return {
    activeTab,
    activeLabel,
    changeTab,
  };
};

export default useTabs;
